import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { UsersIcon, ShareIcon, ExportImportIcon } from '../../assets/SVG';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

class ClientSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientNav: [
                {
                    id: 1,
                    url: '/clients',
                    title: 'Client List',
                    bTitle: 'View and manage all clients',
                    icon: <UsersIcon />
                },
                {
                    id: 2,
                    url: '/clients/data-sharing',
                    title: 'Data Sharing',
                    bTitle: 'Manage client data sharing settings',
                    icon: <ShareIcon />
                }
                // Temporarily commented out Export / Import tab
                // {
                //     id: 3,
                //     url: '/clients/export-import',
                //     title: 'Export / Import',
                //     bTitle: 'Export or import client data',
                //     icon: <ExportImportIcon />
                // }
            ]
        }
    }

    handleRemoveClass = () => {
        document.querySelector('body').classList.remove('setting-temps-pages')
    }

    render() {
        return (
            <>
                <div className={`new-setting-menu-bar _market_sidebar`}>
                    <div className='setting-menu-bar'>
                        <ul className='list-unstyled m-0 p-0'>
                            {this.state.clientNav.map((item, i) =>
                                <li key={'client_nav_' + i} onClick={() => this.handleRemoveClass()}>
                                    <NavLink to={item?.url} exact>
                                        <span className='icon'> {item.icon}</span>
                                        <span className='sTitle'>
                                            <strong className='d-block'>{item.title} </strong>
                                            <span className={`text-sm d-block ${item.redclass || ''}`}>{item.bTitle}</span>
                                        </span>
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default withRouter(connect(mapStateToProps)(ClientSidebar));